import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { StarDisplay } from '../common/StarRating';

interface WeightedRatingDisplayProps {
  ratings: Record<string, number>;
  weights: Record<string, number>;
  maxRating?: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function WeightedRatingDisplay({
  ratings,
  weights,
  maxRating = 5,
  size = 'md',
  className,
}: WeightedRatingDisplayProps) {
  const calculateWeightedRating = (): number => {
    const total = Object.entries(ratings).reduce((sum, [key, rating]) => {
      // Ensure rating is a valid number
      const validRating =
        typeof rating === 'number' && !Number.isNaN(rating) ? rating : 0;
      const weight = weights[key] || 0;
      return sum + validRating * weight;
    }, 0);
    return Math.round(total * 10) / 10;
  };

  const weightedRating = calculateWeightedRating();

  // Check if the weighted rating is valid
  if (Number.isNaN(weightedRating) || weightedRating === 0) {
    return null; // Don't render if rating is invalid
  }

  return (
    <div
      className={cn(
        'p-4 bg-blue-50 border border-blue-200 rounded-lg',
        className
      )}
    >
      <div className="flex items-center justify-between">
        <Label className="text-base font-medium">Total Rating</Label>
        <StarDisplay
          rating={weightedRating}
          maxRating={maxRating}
          size={size}
          showValue
        />
      </div>
    </div>
  );
}

export default WeightedRatingDisplay;
